//Loadspinner for fallback
import React from 'react';
import { Spinner, Center } from '@chakra-ui/react';

const LoadSpinner = () => {
  return (
    <Center width={'100%'}>
      <Spinner />
    </Center>
  );
};

export default LoadSpinner;
